export default function NotReached() {
  return (
    <div className="min-h-screen bg-white" data-testid="site-not-reached" style={{ fontFamily: "Roboto, Arial, sans-serif" }}>
      <div className="max-w-[600px] mx-auto pt-[18vh] px-8">
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" className="mb-8">
          <rect x="14" y="8" width="40" height="54" rx="3" stroke="#9aa0a6" strokeWidth="3" fill="none" />
          <path d="M42 8 L54 20 L42 20 Z" fill="#9aa0a6" />
          <circle cx="28" cy="34" r="2.5" fill="#9aa0a6" />
          <circle cx="42" cy="34" r="2.5" fill="#9aa0a6" />
          <path d="M27 46 q8 -6 16 0" stroke="#9aa0a6" strokeWidth="3" fill="none" strokeLinecap="round" />
        </svg>
        <h1 className="text-[22px] font-normal text-[#202124] mb-4">This site can&apos;t be reached</h1>
        <p className="text-[15px] text-[#5f6368] mb-4">
          <span className="font-bold text-[#202124]">{window.location.hostname.replace(/^www\./, "")}</span> took too long to respond.
        </p>
        <p className="text-[15px] text-[#5f6368] mb-1">Try:</p>
        <ul className="list-disc pl-6 text-[15px] text-[#5f6368] space-y-1 mb-6">
          <li>Checking the connection</li>
          <li><span className="text-[#1a73e8]">Checking the proxy and the firewall</span></li>
          <li><span className="text-[#1a73e8]">Running Windows Network Diagnostics</span></li>
        </ul>
        <div className="text-[13px] text-[#5f6368] mb-8">ERR_CONNECTION_TIMED_OUT</div>
        <button
          data-testid="fake-reload-button"
          onClick={() => window.location.reload()}
          className="bg-[#1a73e8] hover:bg-[#1765cc] text-white text-sm font-medium px-6 py-2 rounded"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
